import { ADTokenService } from 'core/services/ADTokenService';
import { BackendTokenService } from 'core/services/BackendTokenService';
import { TokenService } from 'core/services/TokenService';
import { EnvironmentConfig, ENVIRONMENTS } from 'env';

export const tokenService: TokenService =
  EnvironmentConfig.env === ENVIRONMENTS.GLOBAL
    ? ADTokenService
    : BackendTokenService;
